import { commonHeaders, postRequest } from "services/httpHelper";
import {
  CHANGE_PASSWORD,
  LOGIN,
  LOGOUT,
  REGISTER,
  RESET_PASSWORD,
  VERIFY,
  VERIFY_RESET_PASSWORD,
  ACCESS_CARD_OTP_LOGIN,
} from "services/apiURl";
import { fetchProfileDetails } from "store/actions";

export const registerAccount = async (data) => {
  try {
    document.cookie = "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    const response = await postRequest({
      url: `${REGISTER}`,
      headers: commonHeaders,
      // noAuth: true,
      data: data
    });
    return response || {};
  } catch (error) {
    return {};
  }
};

export const verifyOTP = async (data) => {
  try {
    const response = await postRequest({
      url: `${VERIFY}`,
      headers: commonHeaders,
      data: data
    });
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const loginAccount = async (data, dispatch = null, loginMethod) => {


  const loginURL = loginMethod === "otp" ? `${ACCESS_CARD_OTP_LOGIN}` : `${LOGIN}`;
  try {
    const response = await postRequest({
      // url: `${LOGIN}`,
      url: loginURL,
      headers: commonHeaders,
      // noAuth: true,
      data: data
    });

    if (response?.status === 200) {
      dispatch(fetchProfileDetails());
    }
    return response;
  } catch (error) {
    console.log("Login API error:", error);
    if (error?.response) {
      return {
        status: error.response.status,
        data: error.response.data,
        custom_response: error.response.data?.custom_response || error.response.data
      };
    }
    return {};
  }
};

export const logoutAccount = async () => {
  try {
    const response = await postRequest({
      url: `${LOGOUT}`,
      headers: commonHeaders
    });
    return response;
  } catch (error) {
    return {};
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await postRequest({
      url: `${RESET_PASSWORD}`,
      headers: commonHeaders,
      data: data
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const verifyResetPassword = async (data) => {
  try {
    const response = await postRequest({
      url: `${VERIFY_RESET_PASSWORD}`,
      headers: commonHeaders,
      data: data
    });
    return response;
  } catch (error) {
    return {};
  }
};

export const changePassword = async (data) => {
  try {
    const response = await postRequest({
      url: `${CHANGE_PASSWORD}`,
      headers: commonHeaders,
      data: data
    });
    return response;
  } catch (error) {
    return {};
  }
};
